<script setup>
    import { ref, reactive, computed, onBeforeMount, onMounted, defineComponent, getCurrentInstance } from 'vue'
    import { useRoute, useRouter, RouterLink, RouterView } from 'vue-router'
    import { userInfoStore, rewardListStore } from '@/stores/counter.js'
    import { getReqData, loginAPI,  } from '@/util/api'
    import mystical from "@/util/mystical"
    import { showToast } from 'vant'
    
    const route = useRoute()
    const router = useRouter()
    let { proxy } = getCurrentInstance()
    console.log('【proxy】', proxy.$mitt);

    const userStore = userInfoStore()
    const rewardStore = rewardListStore()
    const userInfo = computed(() => {
        return userStore.userInfo
    })
    const showNavList = ref(false)
    const showLoginPop = ref(false)
    let loginObj = ref({
        uname: '',
        upwd: ''
    })
    const navIndex = ref('')

    proxy.$mitt.on('needLogin', (res) => {
        console.log('【需要登陆】', res);
        showLoginPop.value = true
    })

    const routerTo = (info, index) => {
        if ((info == '/trade_m' || info == '/user_info_m') && !userInfo.value) {
            showLoginPop.value = true
            return
        }
        router.push(info)
        showNavList.value = false
        navIndex.value = index
    }

    const configLogin = () => {
        if (!loginObj.value.uname) {
            showToast({ type: 'fail', message: '아이디를 입력해주세요.', className:'toast-fail' })
            return
        }
        if (!loginObj.value.upwd) {
            showToast({ type: 'fail', message: '비밀번호를 입력해주세요.', className:'toast-fail' })
            return
        }
        loginAPI(getReqData(loginObj.value)).then(res => {
            if (res.data.code == 0) {
            showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
            userStore.setUserInfo(res.data.data)
            localStorage.setItem(
                "2G19fZeORY8=",
                mystical.des_encrypt(JSON.stringify(res.data.data))
            );
            localStorage.setItem(
                "FiJISxKHfpo=",
                mystical.des_encrypt(res.data.data.token)
            );
            showLoginPop.value = false
            window.location.reload()
            } else {
            showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
            }
        }).catch(err => {
            console.log('[error]', err);
        })
    }
    const toAppStor = () => {
        window.location.href = JSON.parse(localStorage.getItem('config-record')).download[1].value
    }
    const toGgStor = () => {
        window.location.href = JSON.parse(localStorage.getItem('config-record')).download[0].value
    }
    const toFb = () => {
        window.location.href = JSON.parse(localStorage.getItem('config-record')).download[2].value
    }

    onBeforeMount(() => {
        if (localStorage.getItem("2G19fZeORY8=")) {
            userStore.setUserInfo(JSON.parse(mystical.des_decrypt(localStorage.getItem("2G19fZeORY8="))))
        }
    })
    onMounted(() => {
        console.log('【route】', route.path);
        switch (route.path) {
            case '/m':
                navIndex.value = '1'
                break;
            case '/role_info_m':
                navIndex.value = '2'
                break;
            case '/trade_m':
                navIndex.value = '3'
                break;
            case '/user_info_m':
                navIndex.value = '4'
                break;
        
            default:
                break;
        }
    })
</script>
<template>
    <section>
        <section class="meun-box">
            <aside style="display: flex; align-items: center; padding: 0.04rem 0.16rem; background: rgb(255 255 255 / 20%); border-radius: 6px; margin-right: 22px;">
                <img v-if="navIndex == '1'" src="@/assets/img/nav/navm0101a.png" alt="" style="height: 0.12rem; padding: 0.02rem 0rem;">
                <img v-else src="@/assets/img/nav/navm0101.png" alt="" @click="routerTo('/m', '1')" style="height: 0.12rem; padding: 0.02rem 0rem;">
                <span style="display: block; width: 1.5px; height: 0.15rem; border-radius: 4px; background: rgb(75 123 167 / 65%); margin: 0px 7px;"></span>
                <img v-if="navIndex == '2'" src="@/assets/img/nav/navm0201a.png" alt="" style="height: 0.12rem; padding: 0.02rem 0rem;">
                <img v-else src="@/assets/img/nav/navm0201.png" alt="" @click="routerTo('/role_info_m', '2')" style="height: 0.12rem; padding: 0.02rem 0rem;">
                <span style="display: block; width: 1.5px; height: 0.15rem; border-radius: 4px; background: rgb(75 123 167 / 65%); margin: 0px 7px;"></span>
                <img v-if="navIndex == '3'" src="@/assets/img/nav/navm0301a.png" alt="" style="height: 0.12rem; padding: 0.02rem 0rem;">
                <img v-else src="@/assets/img/nav/navm0301.png" alt="" @click="routerTo('/trade_m', '3')" style="height: 0.12rem; padding: 0.02rem 0rem;">
                <span style="display: block; width: 1.5px; height: 0.15rem; border-radius: 4px; background: rgb(75 123 167 / 65%); margin: 0px 7px;"></span>
                <img v-if="navIndex == '4'" src="@/assets/img/nav/navm0401a.png" alt="" style="height: 0.12rem; padding: 0.02rem 0rem;">
                <img v-else src="@/assets/img/nav/navm0401.png" alt="" @click="routerTo('/user_info_m', '4')" style="height: 0.12rem; padding: 0.02rem 0rem;">
            </aside>
            <img src="@/assets/img/nav/meun-icon.png" alt="" @click="showNavList = true" style="height: 0.23rem; margin-right: 16px;">
        </section>
        <section class="meun-list-box" v-show="showNavList">
            <img class="close-btn" src="@/assets/img/nav/close-icon.png" alt="" @click="showNavList = false">
            <section class="list-box">
                <aside class="list-item">
                    <img src="@/assets/img/nav/navm01.png" alt="" @click="routerTo('/m')" style="height: 0.2rem;">
                </aside>
                <aside class="list-item">
                    <img src="@/assets/img/nav/navm02.png" alt="" @click="routerTo('/role_info_m')" style="height: 0.2rem;">
                </aside>
                <aside class="list-item">
                    <img src="@/assets/img/nav/navm03.png" alt="" @click="routerTo('/trade_m')" style="height: 0.2rem;">
                </aside>
                <aside class="list-item">
                    <img src="@/assets/img/nav/navm04.png" alt="" @click="routerTo('/user_info_m')" style="height: 0.2rem;">
                </aside>
            </section>
            <section style="display: flex; flex-direction: column; align-items: center;">
                <img src="@/assets/img/nav/fb-nav-icon.png" alt="" @click="toFb" style="margin-top: 0.5rem; height: 0.48rem;">
                <aside style="display: flex; justify-content: center; margin-top: 0.32rem;">
                    <img src="@/assets/img/nav/as-icon.png" alt="" @click="toAppStor" style="height: 0.3rem; margin-right: 20px; border: 1px solid #565656; border-radius: 5px;">
                    <img src="@/assets/img/nav/ad-icon.png" alt="" @click="toGgStor" style="height: 0.3rem; margin-left: 20px; border: 1px solid #565656; border-radius: 5px;">
                </aside>
            </section>
        </section>
        <section class="mask-box" v-show="showLoginPop">
            <section class="login-box">
                <aside style="display: flex; justify-content: flex-end; align-items: center; height: 32px; margin-right: 12px; width: 100%;">
                    <img src="@/assets/img/nav/close-icon.png" alt="" @click="showLoginPop = false" style="height: 0.24rem;">
                </aside>
                <aside class="input-box" style="margin-top: 22px;">
                    <img class="icon" src="@/assets/img/nav/nm-icon.png" alt="">
                    <input type="text" v-model="loginObj.uname" placeholder="아이디를 입력해주세요">
                </aside>
                <aside class="input-box" style="margin-top: 18px;">
                    <img class="icon" src="@/assets/img/nav/mm-icon.png" alt="">
                    <input type="password" name="" id="" v-model="loginObj.upwd" placeholder="비밀번호를 입력해주세요">
                </aside>
                <img src="@/assets/img/nav/login-btn.png" alt="" @click="configLogin" style="height: 42px; margin-top: 50px;">
                <aside style="display: flex; justify-content: space-between; margin-top: 40px; width: 316px;">
                    <button @click="routerTo('/m')" style="font-size: 12px; color: rgb(90, 131, 208); border: none; background: none;">건너뛰기</button>
                    <button @click="toFb" style="font-size: 12px; color: rgb(90, 131, 208); border: none; background: none;">비밀번호 찾기</button>
                </aside>
            </section>
        </section>
    </section>
</template>
<style scoped>
    .meun-box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 8;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0.15rem 0rem;
        background: url('../assets/img/nav/meu-bac.png') no-repeat;
        background-size: 100% 100%;
    }
    .meun-list-box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
        background: rgb(0 0 0 / 75%);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .close-btn {
        position: absolute;
        top: 0.16rem;
        right: 0.16rem;
        height: 0.24rem;
    }
    .list-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0.5rem 37px 0px;
        width: 80%;
    }
    .list-box .list-item {
        border-bottom: 2px solid rgb(75 123 167 / 65%);
        padding: 0.28rem 0rem 0.26rem;
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .mask-box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        background: rgb(0 0 0 / 80%);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .login-box {
        width: 350px;
        height: 312px;
        background: url('../assets/img/nav/login-bac.png') no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .input-box {
        width: 326px;
        height: 38px;
        display: flex;
        position: relative;
    }
    .input-box input {
        display: block;
        width: 264px;
        padding: 0px 6px 0px 54px;
        font-size: 13px;
        border: 1px solid rgb(196, 132, 94);
        border-radius: 12px;
    }
    input::placeholder {
        color: #cdcdcd;
    }
    .input-box .icon {
        position: absolute;
        left: 18px;
        top: 50%;
        transform: translateY(-50%);
        width: 18px;
    }
</style>